import { Col, Popover, Space, Typography } from "antd";
import routes from "../../../engine/routes";
import React from "react";
import { useParams } from "react-router-dom";
import { RenderTitle } from "../../../engine/AuthRoute/navigationHelper";
import LogHistory from "../LogHistory";
import { useSelector } from "react-redux";
import { daysJsFormat as datesFormats, roles } from "../../../utils/constants";
import { ActionRoleSpecific } from "../../../engine/AuthRoute";
import { BillAction } from "../BillAction/BillAction";
import dayjs from "../../../utils/dayjs";
import { InfoCircleOutlined } from "@ant-design/icons";
import {useTranslation} from "react-i18next";

export const BillHeader = ({ title }) => {
    const { t } = useTranslation();
  const { loading, bill } = useSelector(state => state.bill);

  const renderlastSent = () => {
    const sentEmails = JSON.parse(JSON.stringify(bill?.sentEmails || []));

    const renderEmail = sent => {
      return (
        <span style={{ color: "#636363" }}>
          <b>{t('BillHeader.sentAt')} </b> {dayjs(sent.date).format(datesFormats.full)} à{" "}
          {sent.tos.map(t => t).join(", ")}
        </span>
      );
    };

    if (sentEmails.length > 0) {
      const last = sentEmails.sort(
        (a, b) => new Date(b.date) - new Date(a.date),
      )[0];

      return (
        <Popover
          content={
            <Space direction={"vertical"}>
              {sentEmails.map(e => renderEmail(e))}
            </Space>
          }
          title="Historique"
        >
          <InfoCircleOutlined />{" "}
          <span style={{ color: "#636363" }}>
            <b>{t('BillHeader.lastSent')} </b> {dayjs(last.date).format(datesFormats.full)}
          </span>
        </Popover>
      );
    } else {
      return <div>{t('BillHeader.neverDent')}</div>;
    }
  };

  return (
    <Col span={24} style={{ marginBottom: 20 }}>
      <ActionRoleSpecific only={[roles.admin, roles.permanance]}>
        <LogHistory updateEndPoint={[loading, bill]} />
      </ActionRoleSpecific>
      <div style={{ textAlign: "right" }}>{renderlastSent()}</div>
      <Space
        style={{
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography.Title level={3} className={""}>
          <RenderTitle title={title} />
        </Typography.Title>
        <BillAction />
      </Space>
    </Col>
  );
};
